export default function accordion(selector) {
  const accordions = Array.from(document.querySelectorAll(selector));
  let activeAccordion = null;

  accordions.forEach(accordion => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const container = accordion.querySelector('[data-accordion-container]');

    if (trigger && container) {
      trigger.addEventListener('click', () => {
        // Если текущий аккордеон уже активен, просто закрываем его
        if (accordion.classList.contains('active')) {
          accordion.classList.remove('active');
          container.style.height = '0px';
          window.removeEventListener('resize', updateActiveHeight);
          activeAccordion = null;
          return;
        }

        // Закрываем предыдущий открытый аккордеон, если он существует
        if (activeAccordion && activeAccordion !== accordion) {
          activeAccordion.classList.remove('active');
          const prevContainer = activeAccordion.querySelector('[data-accordion-container]');
          prevContainer.style.height = '0px';
          window.removeEventListener('resize', updateActiveHeight);
        }

        // Открываем текущий аккордеон
        accordion.classList.add('active');
        updateActiveHeight();
        window.addEventListener('resize', updateActiveHeight);
        activeAccordion = accordion;
      });

      const updateActiveHeight = () => {
        container.style.height = getContentHeight(container) + 'px';
      };

      const getContentHeight = (container) => {
        let height = 0;
        for (const child of container.children) {
          height += child.scrollHeight;
        }
        return height;
      };
    }
  });
}